const routes_bg = [
  {
    path: '/boldlygo',
    name: 'boldlyGo',
    // lazy-loaded when the route is visited.
    component: () => import('../pages/BoldlyGo.vue'),
  }
];

export default routes_bg;